export const HEADER_TITLE_ID = 'backoffice-section-title';
export const HEADER_SUBTITLE_ID = 'backoffice-section-subtitle';
/** ID to set on the main content section */
export const MAIN_CONTENT_ID = 'maincontent';
